import { useEffect, useState } from 'react';
import { Editable, Slate, useSlate, withReact } from 'slate-react';
import { createEditor, Editor, Transforms } from 'slate';
import {
  renderElement,
  renderLeaf,
} from '@/admin/config/overrides/fieldTypes/MarkdownEditor/helpers';

const defaultValue = [
  {
    type: 'paragraph',
    children: [{ text: '' }],
  },
];

const MarkdownWatcher = ({ markdown }: { markdown: any }) => {
  const editor = useSlate();

  useEffect(() => {
    Transforms.delete(editor, {
      at: {
        anchor: Editor.start(editor, []),
        focus: Editor.end(editor, []),
      },
    });

    Transforms.removeNodes(editor, {
      at: [0],
    });

    Transforms.insertNodes(editor, markdown);
  }, [markdown]);

  return <></>;
};

export const RenderMarkdown = ({ children }: { children: any }) => {
  const [editor] = useState(() => withReact(createEditor()));
  return (
    <>
      <Slate editor={editor} initialValue={children || defaultValue}>
        <MarkdownWatcher markdown={children || defaultValue} />
        <Editable
          readOnly
          value={children}
          renderElement={renderElement}
          renderLeaf={renderLeaf}
          disabled
        />
      </Slate>
    </>
  );
};

export default function UniversalMarkdown({
  children: value,
}: {
  children: string | object;
}) {
  if (typeof value === 'string')
    return (
      <RenderMarkdown>
        {value.split('\n').map((line, index) => ({
          type: 'paragraph',
          children: [
            {
              text: line,
            },
          ],
        }))}
      </RenderMarkdown>
    );

  return <RenderMarkdown>{value}</RenderMarkdown>;
}
